export const formatPhoneNumber = (value) => {
    if (!value) return "";
  
    // Remove all non-digit characters
    const cleaned = value.replace(/\D/g, "");
  
    // Format according to (XXX) XXX-XXXX
    if (cleaned.length <= 3) {
      return `(${cleaned}`;
    } else if (cleaned.length <= 6) {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
    } else {
      return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6, 10)}`;
    }
  };  